<template>
    <div>
        <v-card>
            <v-card-title v-if="full_view" class="headline">Добавить участника
            </v-card-title>
            <v-card-text>
            <div class="input-container__search-user">
                <v-text-field
                v-model.trim="search_email"
                outlined
                :placeholder="$t('Step5.email_or_surname')"
                @keyup.enter="searchUser()"
                :loading="loadingTeamUser"
                type="text"
                counter="50"
                maxLength="50"
                >
                <template v-slot:append-outer>
                <v-icon @click="searchUser()" :color="$mainColor">mdi-account-search-outline</v-icon>
                </template>
                </v-text-field>
            </div>
            <!-- <v-list style="width:100%;">
                    <v-list-item-content>
                        <v-list-item-title v-for="(item, i) in added_team" :key="i">
                        {{item.individual.last_name}} {{item.individual.first_name}}
                        <v-icon @click="deleteUserTeam(item)">mdi-close</v-icon>
                        </v-list-item-title>
                    </v-list-item-content>
            </v-list> -->
            </v-card-text>
            <!-- <v-card-text>

            </v-card-text> -->
            <v-card-actions v-if="full_view">
            <v-spacer></v-spacer>
                <v-btn
                    v-if="can_create_new_user"
                    :color="$mainColor"
                    class="ma-2"
                    style="color: white;"
                    @click="dialogCreateNewUser = true">Создать нового
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog max-width="40%" v-model="dialogAddTeamFamily">
            <v-card>
                <v-card-title>Выберите участника</v-card-title>
                <v-card-text>
                    <v-select
                    :items="search_result"
                    item-text="name"
                    item-value="id"
                    placeholder="Выберите участника из результата поиска"
                    v-model="search_result_selected"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="full_view"
                        outlined
                        :color="$mainColor"
                        class="ma-2"
                        @click="dialogCreateNewUser = true">Создать нового
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        class="ma-2"
                        @click="dialogAddTeamFamily = false">{{$t('cancel')}}</v-btn>
                    <v-btn
                        :color="$mainColor"
                        :disabled="search_result_selected == null"
                        class="ma-2"
                        style="color: white;"
                    @click="selectSearchUser(search_result_selected)">{{$t('ExperimentList.add')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="60%" v-model="dialogCreateNewUser" v-if="full_view">
            <new-user
                @closeModal="dialogCreateNewUser = false"
                @createUser="selectSearchUser($event)"
            />

        </v-dialog>

    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import newUser from './newUser.vue'

export default {
    name: 'UserSearch',

    components: {
        newUser,
    },
    data: () => ({
        dialogAddTeamFamily: false,
        search_email: '',
        search_result: [],
        loadingTeamUser: false,
        search_result_selected: null,
        can_create_new_user: false,
        dialogCreateNewUser: false,

    }),
    props: {
        attached_list: [Object, Array],
        full_view: Boolean,
    },

    beforeMount() {
        this.search_email = '';
    },

    methods: {
        ...mapActions([
            'GET_TEAM_INDIVIDUAL',
            'GET_USER_ID_TEAM',
        ]),

        ...mapMutations([
            'UPDATE_OVERLAY',
            'UPDATE_BASE_PROPOSAL_ID',
        ]),

        async searchUser() {
            this.loadingTeamUser = true

            if (/@/.test(this.search_email)) {
                this.GET_USER_ID_TEAM(this.search_email)
                .then(() => {
                    this.search_email = ''
                    this.loadingTeamUser = false
                })
                .catch(e => {
                    this.loadingTeamUser = false
                    console.log('eee', e)
                    if (typeof e.response.data === 'object') this.$messageHelper(e.response.data.message, 'default');
                    else this.$messageHelper(`${this.$t('unknown_error')}`, 'default');
                })
            } else {
                this.search_result = []
                this.GET_TEAM_INDIVIDUAL(this.search_email)
                .then(res => {
                    this.loadingTeamUser = false
                    if (!res || res.length === 0) {
                        this.can_create_new_user = true
                        this.$messageHelper(`${this.$t('Step5.not_user')}`, 'error', 3000)
                    }
                    else{
                        if (res.length !== 0){
                            res.forEach(item => {
                                if(item.profile_id != localStorage.isLoggedIn){
                                    this.search_result.push({
                                    id: item.profile_id,
                                    name: `${item.last_name} ${item.first_name} ${item.middle_name},  ${item.organization} `
                                    })
                                }
                            })
                        }

                        this.dialogAddTeamFamily = true
                        this.search_result_selected = null
                    }
                })
                .catch(e => {
                    this.loadingTeamUser = false
                    if (typeof e.response.data === 'object')
                        this.$messageHelper(e.response.data.message, 'default');
                    else this.$messageHelper(`${this.$t('unknown_error')}`, 'default');
                })
            }

        },

        selectSearchUser(selected_user_id) {
            var is_added = false
            if (this.attached_list.length !== 0) {
                this.attached_list.forEach(item => {
                    if (item.team_profile.id == selected_user_id) {
                        this.$messageHelper(`${this.$t('Step5.member_name__already_been_added')}`, 'error', 5000)
                        is_added = true
                    }
                })
            }
            if(!is_added){
                this.$emit('addUser', selected_user_id)
            }

            this.email = ''
            this.dialogAddTeamFamily = false
        },
    },

    computed: {
        ...mapGetters([
            'GETTERS_INDIVIDUAL',
            'GETTERS_USER_ID_TEAM',
        ]),

    },
    watch: {
        search_email(val) {
            this.can_create_new_user = false
        },

        GETTERS_USER_ID_TEAM(val) {
            var is_added = false
            if (this.attached_list.length !== 0) {
                this.attached_list.forEach(item => {
                if (item.team_profile.id == val.id) {
                    is_added = true
                    this.$messageHelper(`${this.$t('Step5.member_name__already_been_added')}`, 'error', 5000)
                }
                })
            }
            if(!is_added)
                this.$emit('addUser', val.id)

            this.email = ''
            // this.dialogAddTeamFamily = false

        },
    },

}
</script>

<style scoped>
</style>
